<template>
  <div id="app">

    <header>
      <h1 class="center">Simulador de Gerenciamento de Memória</h1>
    </header>
    <main class="container-fluid">

      <div class="row">
        <div class="row">
          <div class="col-lg-1 pr-1">
            <div class="nav-side-menu">
              <i class="fa fa-bars fa-2x toggle-btn" data-toggle="collapse" data-target="#menu-content"></i>
              <div class="menu-list">
                <ul id="menu-content" class="menu-content collapse out">
                  <li data-toggle="collapse" data-target="#add, #add3" class="active collapsed"
                    aria-controls="add add3">
                    <a>
                      <i class="glyphicon glyphicon-cog"></i>
                      <b style="font-size: 17px">Á</b>rea de
                      <b style="font-size: 17px">C</b>onfiguração
                      <span class="arrow"></span>
                    </a>
                  </li>
                  <ul class="sub-menu collapsed collapse in" aria-expanded="false" id="add">
                    <li id="criarProcessos" data-toggle="collapse" data-target="#add1" class="active collapsed"
                      aria-expanded="false">
                      <b style="font-size: 15px">C</b>riar
                      <b style="font-size: 15px">P</b>rocesso
                    </li>

                    <form id="add1" @submit.prevent="criarProcesso">
                      <div style="background: rgb(218, 218, 218)">
                        <div style="text-align: center">
                          <label for="checkGerador">
                            <input @click="randomNumber()" type="checkbox" id="checkbox" name="checkbox"
                              v-model="checked">

                            Gerar processo com valores aleatórios?

                            <button v-if="checked == true" @click="randomNumber()" style="
                                    float: right;
                                    margin-right: 25px;
                                    margin-bottom: 15px;
                                    border-color: rgb(92, 184, 92);
                                    color: rgb(92, 184, 92); 
                                  " class="btn btn-outline-primary" id="btnCad">
                              <input type="hidden" id="processo" v-model="aleatorio[4]">
                              <input type="hidden" id="codigo" v-model="aleatorio[1]">
                              <input type="hidden" id="dado" v-model="aleatorio[2]">
                              <input type="hidden" id="pilha" v-model="aleatorio[3]">
                              <i class="fa fa-cogs" aria-hidden="true"></i>
                              <b> Gerar Processo </b>
                            </button>
                          </label>

                        </div>
                      </div>

                      <div v-if="checked == false">

                        <div class="form-group">
                          <input placeholder="Processo:" style="text-transform: capitalize" type="text" required
                            class="form-control" id="processo" name="processo" @change="
                              $event.target.value = $event.target.value.toUpperCase()
                            " maxlength="1" />
                        </div>

                        <div class="form-group">
                          <input placeholder="Código:" type="number" style="processo" required class="form-control"
                            id="codigo" name="codigo" @change="validaCampo" min="1" maxlength="1" />
                        </div>

                        <div class="form-group">
                          <input placeholder="Dados:" type="number" min="1" required class="form-control" id="dado"
                            name="dado" @change="validaCampo" />
                        </div>
                        <div class="form-group">
                          <input placeholder="Pilha:" type="number" min="1" required class="form-control" id="pilha"
                            name="pilha" @change="validaCampo" />
                        </div>

                        <div id="botoes" style="text-align: center">
                          <button class="btn btn-success" type="submit">
                            <i class="glyphicon glyphicon-plus-sign"></i>
                            Cadastrar
                          </button>
                          <button class="btn btn-danger" type="reset">
                            <i class="glyphicon glyphicon-remove-sign"></i>
                            Cancelar
                          </button>
                        </div>
                      </div>
                    </form>
                  </ul>
                  <ul class="sub-menu collapsed collapse in 2" aria-expanded="true" id="add3">
                    <li id="ListaProcessos" data-toggle="collapse" data-target="#add2" class="active collapsed"
                      aria-expanded="false">
                      <b style="font-size: 15px">L</b>istas de
                      <b style="font-size: 15px">P</b>rocessos
                    </li>
                    <div id="add2" class="row">
                      <div class="col-lg-12">
                        <div class="card">
                          <div class="card-body">

                            <span v-bind:item="item" v-for="(item, index) in arrProcesso" :key="index">

                              <button class="
                                  btn btn-secondary btn-sm
                                  distancia-botao-processos
                                " @click="processoSelecionado = index; processoSelecionado2 = item.sig_processo"
                                :style="
                                  processoSelecionado == index
                                
                                
                                    ? 'font-weight: bold; text-decoration: underline'
                                    : null
                                ">
                                {{ item.sig_processo }}
                              </button>
                              <button @click="removeProcesso(index), processoSelecionado = 0" class="
                                  glyphicon glyphicon-remove-sign
                                  btn btn-danger
                                ">
                              </button>
                              <br />
                            </span>

                          </div>
                        </div>
                      </div>
                    </div>
                  </ul>
                </ul>
              </div>
            </div>
          </div>
          <div class="pr-1; left-page">
            <span v-bind:item="item" v-for="(item, index) in arrProcesso" :key="index">

              <button class="
                                  btn btn-secondary btn-sm
                                  distancia-botao-processos
                                " @click="processoSelecionado = index; processoSelecionado2 = item.sig_processo"
                :style="
                  processoSelecionado == index
                
                
                    ? 'font-weight: bold; text-decoration: underline'
                    : null
                ">
                {{ item.sig_processo }}
              </button>

            </span>
          </div>
          <div class="left-page">

            <div class="col-lg-2 pr-1; center">
              <h4 v-if="arrProcesso.length === 0">Segmentos</h4>
              <span v-if="arrProcesso.length > 0">

                <h4>Segmento 00 - Código</h4>
                <table class="table table-borderless table-memoria-fisica">
                  <thead>
                    <tr>
                      <th>Deslocamento</th>
                      <th>Bytes</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in arrProcesso[processoSelecionado]
                    .codigo.segmentos" :bgcolor="
    arrProcesso[processoSelecionado].codigo.corFundo
  " :key="arrProcesso[processoSelecionado]
.codigo.segmentos.deslocamento">

                      <td>{{ item.deslocamento }}</td>
                      <td>{{ item.bytes }}</td>
                    </tr>
                  </tbody>
                </table>
                <h4>Segmento 01 - Dados</h4>
                <table class="table table-borderless table-memoria-fisica">
                  <thead>
                    <tr>

                      <th>Deslocamento</th>
                      <th>Bytes</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in arrProcesso[processoSelecionado].dado
                    .segmentos" :bgcolor="arrProcesso[processoSelecionado].dado.corFundo" :key="arrProcesso[processoSelecionado].dado
  .segmentos.deslocamento">

                      <td>{{ item.deslocamento }}</td>
                      <td>{{ item.bytes }}</td>
                    </tr>
                  </tbody>
                </table>
                <h4>Segmento 10 - Pilha</h4>
                <table class="table table-borderless table-memoria-fisica">
                  <thead>
                    <tr>
                      <th>Deslocamento</th>
                      <th>Bytes</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in arrProcesso[processoSelecionado]
                    .pilha.segmentos" :bgcolor="
    arrProcesso[processoSelecionado].pilha.corFundo
  " :key="arrProcesso[processoSelecionado]
.pilha.segmentos.deslocamento">
                      <td>{{ item.deslocamento }}</td>
                      <td>{{ item.bytes }}</td>
                    </tr>
                  </tbody>
                </table>
              </span>
            </div>
            <div class="col-lg-2 pl-1 ; center">
              <h4>Tabela de Segmentos</h4>
              <span v-if="arrTabelaSegmentos.length > 0">
                <table class="table table-borderless table-memoria-fisica">
                  <thead>
                    <tr>
                      <th>Segmento</th>
                      <th>Base</th>
                      <th>Limite</th>
                    </tr>
                  </thead>
                  <tbody v-for="(item, index) in arrTabelaSegmentos[
                    processoSelecionado
                  ]" :bgcolor="item.corFundo" :key="index">
                    <tr v-if="index != 'sig_processo'">
                      <td>{{ item.segmento }}</td>
                      <td>{{ item.base }}</td>
                      <td>{{ item.limite }}</td>
                    </tr>
                  </tbody>
                </table>
              </span>
            </div>


            <div class="col-lg-2 pl-0; center">
              <h4 class="center-right">Memória</h4>
              <table class="table table-borderless table-memoria-fisica">
                <thead>
                  <tr>
                    <th>Endereço</th>
                    <th>Byte</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="index < 16" v-for="(item, index) in arrMemoriaFisica" :bgcolor="
                    item.byte !== '' ? item.corFundo : '#3b8c58'
                  " :key="index">
                    <td>{{ item.endereco }}</td>
                    <td>{{ item.byte }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="col-lg-2">
              <h4>Física</h4>
              <table class="table table-borderless table-memoria-fisica">
                <thead>
                  <tr>
                    <th>Endereço</th>
                    <th>Byte</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="index >= 16" v-for="(item, index) in arrMemoriaFisica" :bgcolor="
                    item.byte !== '' ? item.corFundo : '#4db473'
                  " :key="index">
                    <td>{{ item.endereco }}</td>
                    <td>{{ item.byte }}</td>
                  </tr>
                </tbody>
              </table>
            </div>


          </div>
        </div>
        <small class="form-text text-muted">*Tamanho da Memória Física Fixado: 32 Bytes</small>
      </div>
    </main>
    <footer></footer>
  </div>
</template>

<script>

export default {
  data: function () {
    return {
      checked: false,
      posicao: [],
      processoSelecionado: 0,
      aleatorio: [
        64
      ],
      arrProcesso: [

      ],
      arrTabelaSegmentos: [

      ],
      /* Também Representa os Deslocamentos dos segmentos*/
      arrMemoriaFisica: [
        { posicao: 0, endereco: "00000", byte: "" },
        { posicao: 1, endereco: "00001", byte: "" },
        { posicao: 2, endereco: "00010", byte: "" },
        { posicao: 3, endereco: "00011", byte: "" },
        { posicao: 4, endereco: "00100", byte: "" },
        { posicao: 5, endereco: "00101", byte: "" },
        { posicao: 6, endereco: "00110", byte: "" },
        { posicao: 7, endereco: "00111", byte: "" },
        { posicao: 8, endereco: "01000", byte: "" },
        { posicao: 9, endereco: "01001", byte: "" },
        { posicao: 10, endereco: "01010", byte: "" },
        { posicao: 11, endereco: "01011", byte: "" },
        { posicao: 12, endereco: "01100", byte: "" },
        { posicao: 13, endereco: "01101", byte: "" },
        { posicao: 14, endereco: "01110", byte: "" },
        { posicao: 15, endereco: "01111", byte: "" },
        { posicao: 16, endereco: "10000", byte: "" },
        { posicao: 17, endereco: "10001", byte: "" },
        { posicao: 18, endereco: "10010", byte: "" },
        { posicao: 19, endereco: "10011", byte: "" },
        { posicao: 20, endereco: "10100", byte: "" },
        { posicao: 21, endereco: "10101", byte: "" },
        { posicao: 22, endereco: "10110", byte: "" },
        { posicao: 23, endereco: "10111", byte: "" },
        { posicao: 24, endereco: "11000", byte: "" },
        { posicao: 25, endereco: "11001", byte: "" },
        { posicao: 26, endereco: "11010", byte: "" },
        { posicao: 27, endereco: "11011", byte: "" },
        { posicao: 28, endereco: "11100", byte: "" },
        { posicao: 29, endereco: "11101", byte: "" },
        { posicao: 30, endereco: "11110", byte: "" },
        { posicao: 31, endereco: "11111", byte: "" },
      ],
    };
  },
  methods: {

    randomNumber() {
      if (this.aleatorio[0] == 90)
        this.aleatorio[0] = 64;

      this.aleatorio[0] = this.aleatorio[0] + 1;
      for (var i = 1; i < 4; i++) {
        this.aleatorio[i] = Math.floor(Math.random() * (4 - 1 + 1)) + 1
      };
      this.aleatorio[4] = String.fromCharCode(this.aleatorio[0]);

      return;
    },
    removeProcesso(id) {


      const size = this.arrTabelaSegmentos[id].segmento00.base.length - 1;
      var valor = 0;

      for (
        var z = 0; z <= this.arrTabelaSegmentos[id].segmento00.base.length - 1; z++
      ) {
        const position =
          this.arrTabelaSegmentos[id].segmento00.base.length - 1 - z;
        const bit =
          this.arrTabelaSegmentos[id].segmento00.base.charAt(position);

        if (bit == 1) {
          valor += Math.pow(2, z);
        }
      }

      for (var j = 0; j < this.arrTabelaSegmentos[id].segmento00.tamanho; j++) {
        this.arrMemoriaFisica[valor + j].byte = "";
        this.arrMemoriaFisica[valor + j].corFundo = null;
      }


      valor = 0;

      for (
        var z = 0; z <= this.arrTabelaSegmentos[id].segmento01.base.length - 1; z++
      ) {
        const position =
          this.arrTabelaSegmentos[id].segmento01.base.length - 1 - z;
        const bit =
          this.arrTabelaSegmentos[id].segmento01.base.charAt(position);

        if (bit == 1) {
          valor += Math.pow(2, z);
        }
      }

      for (var j = 0; j < this.arrTabelaSegmentos[id].segmento01.tamanho; j++) {
        this.arrMemoriaFisica[valor + j].byte = "";
        this.arrMemoriaFisica[valor + j].corFundo = null;
      }

      valor = 0;

      for (
        var z = 0; z <= this.arrTabelaSegmentos[id].segmento10.base.length - 1; z++
      ) {
        const position =
          this.arrTabelaSegmentos[id].segmento10.base.length - 1 - z;
        const bit =
          this.arrTabelaSegmentos[id].segmento10.base.charAt(position);

        if (bit == 1) {
          valor += Math.pow(2, z);
        }
      }

      for (var j = 0; j < this.arrTabelaSegmentos[id].segmento10.tamanho; j++) {
        this.arrMemoriaFisica[valor + j].byte = "";
        this.arrMemoriaFisica[valor + j].corFundo = null;
      }

      this.arrTabelaSegmentos.splice(id, 1);


      this.arrProcesso.splice(id, 1);


      return;


    },

    criarProcesso(event) {
      const sig_processo = event.target.processo.value;
      const codigo = event.target.codigo.value;
      const dado = event.target.dado.value;
      const pilha = event.target.pilha.value;

      //Verifica se a sigla/nome do processo já foi cadastrado
      for (const item of this.arrProcesso) {
        if (item.sig_processo === sig_processo) {
          alert(`Processo "${sig_processo}" já cadastrado.`);
          return;
        }
      }

      //Verifica se há espaço na memória física


      if (
        parseInt(codigo) + parseInt(dado) + parseInt(pilha) >
        this.arrMemoriaFisica.filter((item) => item.byte === "").length
      ) {

        alert("não tem memória física suficiente.");
        return;
      }
      var z = 0, i = 0, c = true, d = true, p = true, cc = parseInt(codigo), dd = parseInt(dado), pp = parseInt(pilha), aux;
      for (var aux = 0; aux < 32; aux++) {
        if (this.arrMemoriaFisica[aux].byte == "") {
          i++;
        } else {

          if (cc + dd >= cc + pp) {
            if (cc + dd >= dd + pp) {
              if (cc + dd <= i && c && d) {
                c = false;
                d = false;
                cc = false;
                dd = false;
                i = 0;
                this.posicao[z] = 1;
                z++;
              }
              if (cc >= dd + pp) {
                if (cc <= i && c) {
                  c = false;
                  cc = false;
                  i = 0;
                  this.posicao[z] = 4;
                  z++;
                }
              }
              if (dd >= cc + pp) {
                if (dd <= i && d) {
                  d = false;
                  dd = false;
                  i = 0;
                  this.posicao[z] = 6;
                  z++;
                }
              }
              if (pp >= cc + dd) {
                if (pp <= i && p) {

                  p = false;
                  pp = false;
                  i = 0;
                  this.posicao[z] = 5;
                  z++;
                }
              }
            } else {
              if (dd + pp <= i && d && p) {
                d = false;
                p = false;
                dd = false;
                pp = false;
                i = 0;
                this.posicao[z] = 2;
                z++;
              } if (cc >= dd + pp) {
                if (cc <= i && c) {
                  c = false;
                  cc = false;
                  i = 0;
                  this.posicao[z] = 4;
                  z++;
                }
              }
              if (dd >= cc + pp) {
                if (dd <= i && d) {
                  d = false;
                  dd = false;
                  i = 0;
                  this.posicao[z] = 6;
                  z++;
                }
              }
              if (pp >= cc + dd) {
                if (pp <= i && p) {

                  p = false;
                  pp = false;
                  i = 0;
                  this.posicao[z] = 5;
                  z++;
                }
              }
            }

          }



          if (cc + pp >= dd + pp) {
            if (cc + pp <= i && c && p) {
              c = false;
              p = false;
              cc = false;
              pp = false;
              i = 0;
              this.posicao[z] = 3;
              z++;
            }
            if (cc >= dd + pp) {
              if (cc <= i && c) {
                c = false;
                cc = false;
                i = 0;
                this.posicao[z] = 4;
                z++;
              }
            }
            if (dd >= cc + pp) {
              if (dd <= i && d) {
                d = false;
                dd = false;
                i = 0;
                this.posicao[z] = 6;
                z++;
              }
            }
            if (pp >= cc + dd) {
              if (pp <= i && p) {

                p = false;
                pp = false;
                i = 0;
                this.posicao[z] = 5;
                z++;
              }
            }
          }

          if (dd + pp <= i && d && p) {
            d = false;
            p = false;
            dd = false;
            pp = false;
            i = 0;
            this.posicao[z] = 2;
            z++;
          }
          if (cc >= dd + pp) {
            if (cc <= i && c) {
              c = false;
              cc = false;
              i = 0;
              this.posicao[z] = 4;
              z++;
            }
          }
          if (dd >= cc + pp) {
            if (dd <= i && d) {
              d = false;
              dd = false;
              i = 0;
              this.posicao[z] = 6;
              z++;
            }
          }
          if (pp >= cc + dd) {
            if (pp <= i && p) {

              p = false;
              pp = false;
              i = 0;
              this.posicao[z] = 5;
              z++;
            }
          }
          if (cc + dd >= cc + pp) {
            if (cc + dd <= i && c && d) {
              c = false;
              d = false;
              cc = false;
              dd = false;
              i = 0;
              this.posicao[z] = 1;
              z++;
            } else if (cc + pp <= i && c && p) {
              c = false;
              p = false;
              cc = false;
              pp = false;
              i = 0;
              this.posicao[z] = 3;
              z++;
            }
          } else if (cc + pp <= i && c && p) {
            c = false;
            p = false;
            cc = false;
            pp = false;
            i = 0;
            this.posicao[z] = 3;
            z++;
          } else if (cc + dd <= i && c && d) {
            c = false;
            d = false;
            cc = false;
            dd = false;
            i = 0;
            this.posicao[z] = 1;
            z++;
          }




          if (cc >= dd) {
            if (cc >= pp) {
              if (cc <= i && c) {
                c = false;
                cc = false;
                i = 0;
                this.posicao[z] = 4;
                z++;
              }
            } else if (pp <= i && p) {

              p = false;
              pp = false;
              i = 0;
              this.posicao[z] = 5;
              z++;
            }
          }

          if (dd >= pp) {
            if (dd <= i && d) {
              d = false;
              dd = false;
              i = 0;
              this.posicao[z] = 6;
              z++;
            }
          }
          if (pp <= i && p) {
            p = false;
            pp = false;
            i = 0;
            this.posicao[z] = 5;
            z++;
          }
          if (cc >= dd) {
            if (cc <= i && c) {
              c = false;
              cc = false;
              i = 0;
              this.posicao[z] = 4;
              z++;
            } else if (dd <= i && d) {
              d = false;
              dd = false;
              i = 0;
              this.posicao[z] = 6;
              z++;
            }
          } else if (dd <= i && d) {
            d = false;
            dd = false;
            i = 0;
            this.posicao[z] = 6;
            z++;
          } else if (cc <= i && c) {
            c = false;
            cc = false;
            i = 0;
            this.posicao[z] = 4;
            z++;
          }


          i = 0;
        }
        if (parseInt(codigo) + parseInt(dado) + parseInt(pilha) <= i || !c && !d && !p) {
          aux = 33;
          p = false;
          d = false;
          c = false;
          this.posicao[z] = 7;
        }
      } if (cc + dd >= cc + pp) {
        if (cc + dd >= dd + pp) {
          if (cc + dd <= i && c && d) {
            c = false;
            d = false;
            cc = false;
            dd = false;
            i = 0;
            this.posicao[z] = 1;
            z++;
          }
          if (cc >= dd + pp) {
            if (cc <= i && c) {
              c = false;
              cc = false;
              i = 0;
              this.posicao[z] = 4;
              z++;
            }
          }
          if (dd >= cc + pp) {
            if (dd <= i && d) {
              d = false;
              dd = false;
              i = 0;
              this.posicao[z] = 6;
              z++;
            }
          }
          if (pp >= cc + dd) {
            if (pp <= i && p) {

              p = false;
              pp = false;
              i = 0;
              this.posicao[z] = 5;
              z++;
            }
          }
        } else {
          if (dd + pp <= i && d && p) {
            d = false;
            p = false;
            dd = false;
            pp = false;
            i = 0;
            this.posicao[z] = 2;
            z++;
          } if (cc >= dd + pp) {
            if (cc <= i && c) {
              c = false;
              cc = false;
              i = 0;
              this.posicao[z] = 4;
              z++;
            }
          }
          if (dd >= cc + pp) {
            if (dd <= i && d) {
              d = false;
              dd = false;
              i = 0;
              this.posicao[z] = 6;
              z++;
            }
          }
          if (pp >= cc + dd) {
            if (pp <= i && p) {

              p = false;
              pp = false;
              i = 0;
              this.posicao[z] = 5;
              z++;
            }
          }
        }

      }



      if (cc + pp >= dd + pp) {
        if (cc + pp <= i && c && p) {
          c = false;
          p = false;
          cc = false;
          pp = false;
          i = 0;
          this.posicao[z] = 3;
          z++;
        }
        if (cc >= dd + pp) {
          if (cc <= i && c) {
            c = false;
            cc = false;
            i = 0;
            this.posicao[z] = 4;
            z++;
          }
        }
        if (dd >= cc + pp) {
          if (dd <= i && d) {
            d = false;
            dd = false;
            i = 0;
            this.posicao[z] = 6;
            z++;
          }
        }
        if (pp >= cc + dd) {
          if (pp <= i && p) {

            p = false;
            pp = false;
            i = 0;
            this.posicao[z] = 5;
            z++;
          }
        }
      }

      if (dd + pp <= i && d && p) {
        d = false;
        p = false;
        dd = false;
        pp = false;
        i = 0;
        this.posicao[z] = 2;
        z++;
      }
      if (cc >= dd + pp) {
        if (cc <= i && c) {
          c = false;
          cc = false;
          i = 0;
          this.posicao[z] = 4;
          z++;
        }
      }
      if (dd >= cc + pp) {
        if (dd <= i && d) {
          d = false;
          dd = false;
          i = 0;
          this.posicao[z] = 6;
          z++;
        }
      }
      if (pp >= cc + dd) {
        if (pp <= i && p) {

          p = false;
          pp = false;
          i = 0;
          this.posicao[z] = 5;
          z++;
        }
      }
      if (cc + dd >= cc + pp) {
        if (cc + dd <= i && c && d) {
          c = false;
          d = false;
          cc = false;
          dd = false;
          i = 0;
          this.posicao[z] = 1;
          z++;
        } else if (cc + pp <= i && c && p) {
          c = false;
          p = false;
          cc = false;
          pp = false;
          i = 0;
          this.posicao[z] = 3;
          z++;
        }
      } else if (cc + pp <= i && c && p) {
        c = false;
        p = false;
        cc = false;
        pp = false;
        i = 0;
        this.posicao[z] = 3;
        z++;
      } else if (cc + dd <= i && c && d) {
        c = false;
        d = false;
        cc = false;
        dd = false;
        i = 0;
        this.posicao[z] = 1;
        z++;
      }




      if (cc >= dd) {
        if (cc >= pp) {
          if (cc <= i && c) {
            c = false;
            cc = false;
            i = 0;
            this.posicao[z] = 4;
            z++;
          }
        } else if (pp <= i && p) {

          p = false;
          pp = false;
          i = 0;
          this.posicao[z] = 5;
          z++;
        }
      }

      if (dd >= pp) {
        if (dd <= i && d) {
          d = false;
          dd = false;
          i = 0;
          this.posicao[z] = 6;
          z++;
        }
      }
      if (pp <= i && p) {
        p = false;
        pp = false;
        i = 0;
        this.posicao[z] = 5;
        z++;
      }
      if (cc >= dd) {
        if (cc <= i && c) {
          c = false;
          cc = false;
          i = 0;
          this.posicao[z] = 4;
          z++;
        } else if (dd <= i && d) {
          d = false;
          dd = false;
          i = 0;
          this.posicao[z] = 6;
          z++;
        }
      } else if (dd <= i && d) {
        d = false;
        dd = false;
        i = 0;
        this.posicao[z] = 6;
        z++;
      } else if (cc <= i && c) {
        c = false;
        cc = false;
        i = 0;
        this.posicao[z] = 4;
        z++;
      }


      if (!c && !d && !p) {
        aux = 33;
      } else if (aux == 32) {
        alert("Não tem espaço suficiente nas lacunas para os segmentos.");
        return;
      }
      const novoProcesso = {
        id: this.arrProcesso.length,
        sig_processo,
        codigo: {
          tamanho: codigo,
          segmentos: this.criarSegmento(codigo, "codigo"),
          corFundo: this.geraCorAleatoria(),
        },
        dado: {
          tamanho: dado,
          segmentos: this.criarSegmento(dado, "dado"),
          corFundo: this.geraCorAleatoria(),
        },
        pilha: {
          tamanho: pilha,
          segmentos: this.criarSegmento(pilha, "pilha"),
          corFundo: this.geraCorAleatoria(),
        },
      };

      //Adiciona o novo processo na lista
      this.arrProcesso.push(novoProcesso);

      //Preencher Memoria fisica e monta a tabela de segmentos
      this.preencherMemoriaFisica(novoProcesso);

      //Selecionar o processo atual
      this.processoSelecionado = this.arrProcesso.length - 1;

      //Limpa Campo
      this.limparCampos(event);
    },

    criarSegmento(numberTamanho, strSegmento) {
      var arrSegmento = [];
      var objAux = {};
      for (var i = 0; i < numberTamanho; i++) {
        if (strSegmento === "codigo") {
          objAux.bytes = "C" + (i + 1);
        } else if (strSegmento === "dado") {
          objAux.bytes = "D" + (i + 1);
        } else if (strSegmento === "pilha") {
          objAux.bytes = "P" + (i + 1);
        }
        objAux.deslocamento = this.arrMemoriaFisica[i].endereco;
        arrSegmento.push(objAux);
        objAux = {};
      }
      return arrSegmento;
    },
    preencherMemoriaFisica(novoProcesso) {
      const self = this;

      function preencher(tamanho, arr, corFundo) {
        var aux = 0;
        var base;
        var limite;
        var m = 0;
        const memoriaFisicaLivre = self.arrMemoriaFisica.filter(
          (i) => i.byte === ""
        );
        for (var i = 0; i < tamanho - 1; i++) {
          if (
            memoriaFisicaLivre[i].posicao !=
            memoriaFisicaLivre[i + 1].posicao - 1
          ) {

            m = i + 1;
          }

        }



        for (m; m < memoriaFisicaLivre.length; m++) {
          if (aux === 0) {
            //base
            base = memoriaFisicaLivre[m].endereco;
          }

          for (var i = aux; i < arr.length; i++) {
            memoriaFisicaLivre[m].byte = arr[i].bytes;
            aux++;
            break;
          }
          memoriaFisicaLivre[m].corFundo = corFundo;
          if (aux == arr.length) {
            limite = aux.toString(2);
            while (limite.length < 4)
              limite = 0 + limite;
            break;
          }
        }
        return {

          base,
          limite,
        };
      }


      if (this.posicao[0] == 7 || this.posicao[0] == 4 && this.posicao[1] == 6 || this.posicao[0] == 1 || this.posicao[1] == 2) {
        const codigoBaseLimite = preencher(
          novoProcesso.codigo.tamanho,
          novoProcesso.codigo.segmentos,
          novoProcesso.codigo.corFundo
        );

        const dadoBaseLimite = preencher(
          novoProcesso.dado.tamanho,
          novoProcesso.dado.segmentos,
          novoProcesso.dado.corFundo

        );
        const pilhaBaseLimite = preencher(
          novoProcesso.pilha.tamanho,
          novoProcesso.pilha.segmentos,
          novoProcesso.pilha.corFundo
        );
        const novaTabela = {
          sig_processo: novoProcesso.sig_processo,
          segmento00: {
            tamanho: novoProcesso.codigo.tamanho,
            segmento: "00",
            base: codigoBaseLimite.base,
            limite: codigoBaseLimite.limite,
            corFundo: novoProcesso.codigo.corFundo,
          },
          segmento01: {
            tamanho: novoProcesso.dado.tamanho,
            segmento: "01",
            base: dadoBaseLimite.base,
            limite: dadoBaseLimite.limite,
            corFundo: novoProcesso.dado.corFundo,
          },
          segmento10: {
            tamanho: novoProcesso.pilha.tamanho,
            segmento: "10",
            base: pilhaBaseLimite.base,
            limite: pilhaBaseLimite.limite,
            corFundo: novoProcesso.pilha.corFundo,
          },
        };
        this.arrTabelaSegmentos.push(
          novaTabela
        );


      }



      if (this.posicao[0] == 3 || this.posicao[0] == 4 && this.posicao[1] == 5) {
        const codigoBaseLimite = preencher(
          novoProcesso.codigo.tamanho,
          novoProcesso.codigo.segmentos,
          novoProcesso.codigo.corFundo
        ); const pilhaBaseLimite = preencher(
          novoProcesso.pilha.tamanho,
          novoProcesso.pilha.segmentos,
          novoProcesso.pilha.corFundo
        );
        const dadoBaseLimite = preencher(
          novoProcesso.dado.tamanho,
          novoProcesso.dado.segmentos,
          novoProcesso.dado.corFundo

        );
        const novaTabela = {
          sig_processo: novoProcesso.sig_processo,
          segmento00: {
            tamanho: novoProcesso.codigo.tamanho,
            segmento: "00",
            base: codigoBaseLimite.base,
            limite: codigoBaseLimite.limite,
            corFundo: novoProcesso.codigo.corFundo,
          },
          segmento01: {
            tamanho: novoProcesso.dado.tamanho,
            segmento: "01",
            base: dadoBaseLimite.base,
            limite: dadoBaseLimite.limite,
            corFundo: novoProcesso.dado.corFundo,
          },
          segmento10: {
            tamanho: novoProcesso.pilha.tamanho,
            segmento: "10",
            base: pilhaBaseLimite.base,
            limite: pilhaBaseLimite.limite,
            corFundo: novoProcesso.pilha.corFundo,
          },
        };
        this.arrTabelaSegmentos.push(
          novaTabela
        );
      }









      if (this.posicao[1] == 3 || this.posicao[0] == 6 && this.posicao[1] == 4) {
        const dadoBaseLimite = preencher(
          novoProcesso.dado.tamanho,
          novoProcesso.dado.segmentos,
          novoProcesso.dado.corFundo
        );
        const codigoBaseLimite = preencher(
          novoProcesso.codigo.tamanho,
          novoProcesso.codigo.segmentos,
          novoProcesso.codigo.corFundo
        ); const pilhaBaseLimite = preencher(
          novoProcesso.pilha.tamanho,
          novoProcesso.pilha.segmentos,
          novoProcesso.pilha.corFundo
        );

        const novaTabela = {
          sig_processo: novoProcesso.sig_processo,
          segmento00: {
            tamanho: novoProcesso.codigo.tamanho,
            segmento: "00",
            base: codigoBaseLimite.base,
            limite: codigoBaseLimite.limite,
            corFundo: novoProcesso.codigo.corFundo,
          },
          segmento01: {
            tamanho: novoProcesso.dado.tamanho,
            segmento: "01",
            base: dadoBaseLimite.base,
            limite: dadoBaseLimite.limite,
            corFundo: novoProcesso.dado.corFundo,
          },
          segmento10: {
            tamanho: novoProcesso.pilha.tamanho,
            segmento: "10",
            base: pilhaBaseLimite.base,
            limite: pilhaBaseLimite.limite,
            corFundo: novoProcesso.pilha.corFundo,
          },
        };
        this.arrTabelaSegmentos.push(
          novaTabela
        );

      }




      if (this.posicao[0] == 2 || this.posicao[0] == 6 && this.posicao[1] == 5) {
        const dadoBaseLimite = preencher(
          novoProcesso.dado.tamanho,
          novoProcesso.dado.segmentos,
          novoProcesso.dado.corFundo

        ); const pilhaBaseLimite = preencher(
          novoProcesso.pilha.tamanho,
          novoProcesso.pilha.segmentos,
          novoProcesso.pilha.corFundo
        );
        const codigoBaseLimite = preencher(
          novoProcesso.codigo.tamanho,
          novoProcesso.codigo.segmentos,
          novoProcesso.codigo.corFundo
        );
        const novaTabela = {
          sig_processo: novoProcesso.sig_processo,
          segmento00: {
            tamanho: novoProcesso.codigo.tamanho,
            segmento: "00",
            base: codigoBaseLimite.base,
            limite: codigoBaseLimite.limite,
            corFundo: novoProcesso.codigo.corFundo,
          },
          segmento01: {
            tamanho: novoProcesso.dado.tamanho,
            segmento: "01",
            base: dadoBaseLimite.base,
            limite: dadoBaseLimite.limite,
            corFundo: novoProcesso.dado.corFundo,
          },
          segmento10: {
            tamanho: novoProcesso.pilha.tamanho,
            segmento: "10",
            base: pilhaBaseLimite.base,
            limite: pilhaBaseLimite.limite,
            corFundo: novoProcesso.pilha.corFundo,
          },
        };
        this.arrTabelaSegmentos.push(
          novaTabela
        );

      }


      if (this.posicao[1] == 1 || this.posicao[0] == 5 && this.posicao[1] == 4) {
        const pilhaBaseLimite = preencher(
          novoProcesso.pilha.tamanho,
          novoProcesso.pilha.segmentos,
          novoProcesso.pilha.corFundo
        );
        const codigoBaseLimite = preencher(
          novoProcesso.codigo.tamanho,
          novoProcesso.codigo.segmentos,
          novoProcesso.codigo.corFundo
        );
        const dadoBaseLimite = preencher(
          novoProcesso.dado.tamanho,
          novoProcesso.dado.segmentos,
          novoProcesso.dado.corFundo

        );
        const novaTabela = {
          sig_processo: novoProcesso.sig_processo,
          segmento00: {
            tamanho: novoProcesso.codigo.tamanho,
            segmento: "00",
            base: codigoBaseLimite.base,
            limite: codigoBaseLimite.limite,
            corFundo: novoProcesso.codigo.corFundo,
          },
          segmento01: {
            tamanho: novoProcesso.dado.tamanho,
            segmento: "01",
            base: dadoBaseLimite.base,
            limite: dadoBaseLimite.limite,
            corFundo: novoProcesso.dado.corFundo,
          },
          segmento10: {
            tamanho: novoProcesso.pilha.tamanho,
            segmento: "10",
            base: pilhaBaseLimite.base,
            limite: pilhaBaseLimite.limite,
            corFundo: novoProcesso.pilha.corFundo,
          },
        };
        this.arrTabelaSegmentos.push(
          novaTabela
        );

      }




      if (this.posicao[0] == 5 && this.posicao[1] == 6) {
        const pilhaBaseLimite = preencher(
          novoProcesso.pilha.tamanho,
          novoProcesso.pilha.segmentos,
          novoProcesso.pilha.corFundo
        );
        const dadoBaseLimite = preencher(
          novoProcesso.dado.tamanho,
          novoProcesso.dado.segmentos,
          novoProcesso.dado.corFundo

        );

        const codigoBaseLimite = preencher(
          novoProcesso.codigo.tamanho,
          novoProcesso.codigo.segmentos,
          novoProcesso.codigo.corFundo
        );

        const novaTabela = {
          sig_processo: novoProcesso.sig_processo,
          segmento00: {
            tamanho: novoProcesso.codigo.tamanho,
            segmento: "00",
            base: codigoBaseLimite.base,
            limite: codigoBaseLimite.limite,
            corFundo: novoProcesso.codigo.corFundo,
          },
          segmento01: {
            tamanho: novoProcesso.dado.tamanho,
            segmento: "01",
            base: dadoBaseLimite.base,
            limite: dadoBaseLimite.limite,
            corFundo: novoProcesso.dado.corFundo,
          },
          segmento10: {
            tamanho: novoProcesso.pilha.tamanho,
            segmento: "10",
            base: pilhaBaseLimite.base,
            limite: pilhaBaseLimite.limite,
            corFundo: novoProcesso.pilha.corFundo,
          },
        };
        this.arrTabelaSegmentos.push(
          novaTabela
        );

      }











    },

    geraCorAleatoria() {

// const sig_processo = event.target.processo.value;
      if (!(this.aleatorio[5] >= 0)) {
        this.aleatorio[5] = 0;
      }
        if ((this.aleatorio[5] >= 3)) {
        this.aleatorio[5] = 0;
      }
      if (this.aleatorio[5] == 0 && event.target.processo.value=="A") {
        var cor = "#000066";
      } else if (this.aleatorio[5] == 1 && event.target.processo.value=="A") {
        var cor = "#0000aa";
      } else if (this.aleatorio[5] == 2 && event.target.processo.value=="A") {
        var cor = "#0000ff";
      } else if (this.aleatorio[5] == 0 && event.target.processo.value=="B") {
        var cor = "#660000";
      } else if (this.aleatorio[5] == 1 && event.target.processo.value=="B") {
        var cor = "#aa0000";
      } else if (this.aleatorio[5] == 2 && event.target.processo.value=="B") {
        var cor = "#ff0000";
      } else if (this.aleatorio[5] == 0 && event.target.processo.value=="C") {
        var cor = "#444400";
      } else if (this.aleatorio[5] == 1 && event.target.processo.value=="C") {
        var cor = "#888800";
      } else if (this.aleatorio[5] == 2 && event.target.processo.value=="C") {
        var cor = "#cccc00";
      } else if (this.aleatorio[5] == 0 && event.target.processo.value=="D") {
        var cor = "#660066";
      } else if (this.aleatorio[5] == 1 && event.target.processo.value=="D") {
        var cor = "#aa00aa";
      } else if (this.aleatorio[5] == 2 && event.target.processo.value=="D") {
        var cor = "#ff00ff";
      } else if (this.aleatorio[5] == 0 && event.target.processo.value=="E") {
        var cor = "#003333";
      } else if (this.aleatorio[5] == 1 && event.target.processo.value=="E") {
        var cor = "#006666";
      } else if (this.aleatorio[5] == 2 && event.target.processo.value=="E") {
        var cor = "#009999";
      } else if (this.aleatorio[5] == 0 && event.target.processo.value=="F") {
        var cor = "#333333";
      } else if (this.aleatorio[5] == 1 && event.target.processo.value=="F") {
        var cor = "#666666";
      } else if (this.aleatorio[5] == 2 && event.target.processo.value=="F") {
        var cor = "#999999";
      } else if (this.aleatorio[5] == 0 && event.target.processo.value=="G") {
        var cor = "#003300";
      } else if (this.aleatorio[5] == 1 && event.target.processo.value=="G") {
        var cor = "#00aa00";
      } else if (this.aleatorio[5] == 2 && event.target.processo.value=="G") {
        var cor = "#00ff00";
      }else if (this.aleatorio[5] == 0 && event.target.processo.value=="H") {
        var cor = "#773300";
      } else if (this.aleatorio[5] == 1 && event.target.processo.value=="H") {
        var cor = "#AA6633";
      } else if (this.aleatorio[5] == 2 && event.target.processo.value=="H") {
        var cor = "#dd9966";
      }else {
        const hexadecimais = "01235679";
        var cor = "#";
        for (var i = 0; i < 6; i++)
          cor += hexadecimais[Math.floor(Math.random() * 8)];
        return cor;
      }

      this.aleatorio[5] = this.aleatorio[5] + 1;
      return cor;
    },
    validaCampo(event) {
      if (event.target.value <= 0) {
        alert(
          `Campo "${event.target.name.toUpperCase()}" deve ser maior que zero.`
        );
        event.target.value =
          event.target.value <= 0 ? null : event.target.value;
      }
    },
    limparCampos(event) {
      event.target.processo.value = null;
      event.target.codigo.value = null;
      event.target.dado.value = null;
      event.target.pilha.value = null;
    },
    recarregarPagina() {
      location.reload();
    },
  },
};
</script>

